import * as React from "react";
import { SVGProps } from "react";
const SvgInteractiveTool = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={4} fill="#9B92C7" />
    <path
      d="M10.442 15.333h3.115M12 6v.667m4.243 1.09-.472.472M18 12h-.667M6.667 12H6m2.229-3.771-.472-.472m1.886 6.6a3.333 3.333 0 1 1 4.714 0l-.365.365a2.249 2.249 0 0 0-.659 1.59v.355a1.333 1.333 0 1 1-2.666 0v-.354a2.25 2.25 0 0 0-.659-1.591l-.365-.365Z"
      stroke="#fff"
      strokeWidth={1.13}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgInteractiveTool;
